import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DealerHeaderTitle } from 'site-modules/dealerships/components/dealer-header-title/dealer-header-title';

import './dealer-carousel-slide.scss';

export function DealerCarouselSlide({
  photoUrl = '',
  dealerName = '',
  fiveStarDealerAward = [],
  slideNumber = 0,
  isDefaultSlide = false,
}) {
  return (
    <div className="dealer-carousel-slide">
      <div
        className={classNames('dealer-photo', { 'default-photo': isDefaultSlide })}
        style={{ backgroundImage: `url('${photoUrl}')` }}
      />
      {slideNumber === 0 && (
        <div className="slide-content w-100">
          <DealerHeaderTitle dealerName={dealerName} fiveStarDealerAward={fiveStarDealerAward} />
        </div>
      )}
    </div>
  );
}

DealerCarouselSlide.propTypes = {
  dealerName: PropTypes.string,
  slideNumber: PropTypes.number,
  photoUrl: PropTypes.string,
  fiveStarDealerAward: PropTypes.arrayOf(PropTypes.number),
  isDefaultSlide: PropTypes.bool,
};
